<script setup>
import { useLayout } from '@/layout/composables/layout';
import { onBeforeMount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const { layoutState, setActiveMenuItem, toggleMenu } = useLayout();

const props = defineProps({
    item: {
        type: Object,
        default: () => ({})
    },
    index: {
        type: Number,
        default: 0
    },
    root: {
        type: Boolean,
        default: true
    },
    parentItemKey: {
        type: String,
        default: null
    }
});

const isActiveMenu = ref(false);
const itemKey = ref(null);

onBeforeMount(() => {
    itemKey.value = props.parentItemKey ? props.parentItemKey + '-' + props.index : String(props.index);

    const activeItem = layoutState.activeMenuItem;

    isActiveMenu.value = activeItem === itemKey.value || activeItem ? activeItem.startsWith(itemKey.value + '-') : false;
    if (props.item.class === 'daily-quizzes-menu') {
    isActiveMenu.value = true;
} else {
    isActiveMenu.value =
        activeItem === itemKey.value ||
        (activeItem ? activeItem.startsWith(itemKey.value + '-') : false);
}
});

watch(
    () => layoutState.activeMenuItem,
    (newVal) => {
        if (props.item.class === 'daily-quizzes-menu') {
            isActiveMenu.value = true;
            return;
        }

        isActiveMenu.value =
            newVal === itemKey.value ||
            (newVal && newVal.startsWith(itemKey.value + '-'));
    }
);

function itemClick(event, item) {
    if (item.disabled) {
        event.preventDefault();
        return;
    }

    // Daily Quiz parent should not be clickable
    if (item.class === 'daily-quizzes-menu') {
        event.preventDefault();
        event.stopPropagation();
        return;
    }

    if ((item.to || item.url) && (layoutState.staticMenuMobileActive || layoutState.overlayMenuActive)) {
        toggleMenu();
    }

    if (item.command) {
        item.command({ originalEvent: event, item: item });
    }

if (item.isDailyQuiz) {
    event.preventDefault();
    event.stopPropagation();
    return;
}

const foundItemKey = item.items
    ? (isActiveMenu.value ? props.parentItemKey : itemKey.value)
    : itemKey.value;

setActiveMenuItem(foundItemKey);
}

// function checkActiveRoute(item) {
//     return route.path === item.to;
// }
function checkActiveRoute(item) {
    if (item.activeRoutes) {
        return item.activeRoutes.some(routePath => {
            if (routePath.includes(':id')) {
                return route.path.startsWith(routePath.replace('/:id', '/'));
            }

            return route.path === routePath;
        });
    }

    return route.path === item.to;
}
</script>

<template>
    <li :class="{ 'layout-root-menuitem': root, 'active-menuitem': isActiveMenu }">
        <div v-if="root && item.visible !== false" class="layout-menuitem-root-text">{{ item.label }}</div>
        <a
    v-if="(!item.to || item.items) && item.visible !== false"
    :href="item.url"
    @click="itemClick($event, item)"
    :class="[item.class, item.isActiveParent ? 'active-daily-parent' : '']"
    :target="item.target"
    tabindex="0"
>
            <i :class="item.icon" class="layout-menuitem-icon"></i>
            <span class="layout-menuitem-text">{{ item.label }}</span>
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler" v-if="item.items"></i>
        </a>
        <router-link v-if="item.to && !item.items && item.visible !== false" @click="itemClick($event, item, index)" :class="[item.class, { 'active-route': checkActiveRoute(item) }]" tabindex="0" :to="item.to">
            <i :class="item.icon" class="layout-menuitem-icon"></i>
            <span class="layout-menuitem-text">{{ item.label }}</span>
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler" v-if="item.items"></i>
        </router-link>
        <Transition v-if="item.items && item.visible !== false" name="layout-submenu">
            <ul v-show="root ? true : isActiveMenu" class="layout-submenu">
                <app-menu-item v-for="(child, i) in item.items" :key="child" :index="i" :item="child" :parentItemKey="itemKey" :root="false"></app-menu-item>
            </ul>
        </Transition>
    </li>
</template>

<style lang="scss" scoped>
:deep(.daily-quizzes-menu > .layout-submenu) {
    display: block !important;
}

:deep(.daily-quizzes-menu.active-menuitem > .layout-submenu) {
    display: block !important;
}

</style>
